import * as React from 'react';

import { type SortingState } from '@tanstack/react-table';
import { useSearchParams } from 'react-router-dom';

interface useSortingProps {
    initialSortingState?: SortingState;
}
function useSorting({ initialSortingState = [] }: useSortingProps = {}) {
    const [searchParams] = useSearchParams();
    const [sortingState, setSortingState] = React.useState<SortingState>(() => {
        const sorting = searchParams.get('ordering');

        const searchParamsSorting = sorting?.split(',').map((sort) => {
            const desc = sort.startsWith('-');
            const id = desc ? sort.slice(1) : sort;
            return { id, desc };
        });

        return searchParamsSorting ?? initialSortingState;
    });

    const querySortingOptions = React.useMemo(() => {
        let formattedSortingState = sortingState?.map((sort) => (sort.desc ? `-${sort.id}` : sort.id));
        if (formattedSortingState.length == 0) {
            formattedSortingState = initialSortingState.map((sort) => (sort.desc ? `-${sort.id}` : sort.id));
        }
        return { ordering: formattedSortingState?.join(',') };
    }, [sortingState]);

    return { sortingState, setSortingState, querySortingOptions };
}

export default useSorting;
